/**!
 *  Fuse Content Editor Support Widget
 *  Author: Bjorn Tollstrom <bjorn@rodolfo.se>
 */

import React from "react";
import Widget from "../../widget.js";
import API from "Class/API";
import Parser from "Class/Parser";
import Button from "Components/UI/Button";
import "./support.scss";

class WidgetSupport extends Widget
{
    constructor(props)
    {
        super(props);
        this.Fields = this.SetFields({
            title:
            {
                default: "Reload user data",
                insert: true,
                label: "Label",
                reset: true,
                type: "textarea",
                translate: true
            },
            text:
            {
                default: "This can be useful if you've recently been added to a new group or had permissions changed.",
                insert: true,
                label: "Text",
                type: "textarea",
                translate: true
            },
            label:
            {
                default: "Reload",
                insert: true,
                label: "Label",
                type: "text",
                translate: true
            },
            /*action:
            {
                default: "purge",
                type: "select",
                label: "Action",
                options:
                {
                    purge: "Reload user data"
                }
            },*/
        }, {
            backgroundColor: 'transparent',
            textColor: 'black'
        });
        this.Name = "Support";
        this.Translate =
        {
            success: 'User data reloaded successfully.',
            error: 'An error occurred.'
        };
        this.state = {
            error: false,
            loading: false,
            message: ''
        };
    }

    OnPurge = async () =>
    {
        this.setState({loading: true, error: false, message: ''});
        const {error, message} = await API.RequestAsync('auth/purge')
        this.setState({loading: false, error, message});
    }

    render()
    {
        const {error, loading, message} = this.state;
        const {
            action,
            label,
            text,
            title
        } = this.Content();
        const CA = ["WidgetSupport", "BorderRadius"];
        const CS = this.ClassNames(CA, true);
        const ButtonProps = {
            big: true,
            label
        };
        const Message = message ? (error ? this.GetTranslation('error') : this.GetTranslation('success')) : '';
        switch (action)
        {
            default:
                ButtonProps.onClick = this.OnPurge;
        }
        return (
            <div className={CS} ref={widget => this.RefWidget = widget} style={this.Style()}>
                {this.Toolbar()}
                {this.BackgroundImage()}
                <div className="WidgetSupportContent WidgetDynamicAlign">
                    <div className="WidgetSupportTextContainer">
                        {title && <div className="WidgetSupportTitle Heading">{Parser.ParseParagraphs(title)}</div>}
                        {text && <div className="WidgetSupportText">{Parser.ParseParagraphs(text)}</div>}
                    </div>
                    {label ? <Button loading={loading} {...ButtonProps}/> : ""}
                    {Message && <div className={"WidgetSupportMessage " + (error ? "Error" : "Success")}>{Message}</div>}
                </div>
            </div>
       );
    }
}

export default WidgetSupport;